import React from "react";
import { useForm } from "react-hook-form";
import PopupWrapper from "../../../components/PopupWrapper";
import FormBox from "../../../components/FormBox/FormBox";
import { AddRecipientSchema } from "../../../Utils/formOptions";

const AddRecipients = ({ showRecipients, setShowRecipients }) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ ...AddRecipientSchema });

  async function onSubmit(data) {}

  return (
    <PopupWrapper
      title={"Add Recipients"}
      extraClass="width-800"
      Component={
        <div>
          <FormBox
            options={recipientsArr}
            register={register}
            watch={watch}
            setValue={setValue}
            errors={errors}
          />

          <div className="d-flex justify-content-end mt-5">
            <button
              type="button"
              className="btn btn-secondary me-3"
              onClick={() => setShowRecipients(false)}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary text-white"
              onClick={handleSubmit(onSubmit)}
            >
              Create
            </button>
          </div>
        </div>
      }
      toShow={showRecipients}
      closeEventHandler={() => {
        setShowRecipients(false);
      }}
    />
  );
};

export default AddRecipients;

const recipientsArr = [
  //   {
  //     title: "Payoff Id",
  //     field: "PayoffId",
  //     type: "select",
  //     className: "col-6",
  //     options: [
  //       { label: "55F7A46689634B8DA9EBAAA62261C180", value: "5" },
  //       { label: "55F82380727C40CC90C79DA9B42F9414", value: "7" },
  //       { label: "55FE584177E64B25B6DDBC7857BB86A1", value: "6" },
  //       { label: "80C22CCF5A34433ABC218DB037EAF3DD", value: "3" },
  //     ],
  //   },
  {
    title: "Receiver Type",
    field: "ReceiverType",
    type: "select",
    className: "col-12",
    options: [
      { label: "Borrower", value: "Borrower" },
      { label: "Lender", value: "Lender" },
      { label: "Other", value: "Other" },
    ],
  },
  {
    title: "Loanrecid",
    field: "Loanrecid",
    type: "text",
    className: "col-12",
  },
  {
    title: "Ownerredid",
    field: "Ownerredid",
    type: "text",
    className: "col-12",
  },
  {
    title: "Recipient Name",
    field: "RecipientName",
    type: "text",
    className: "col-12",
  },
  {
    title: "Recipient Email",
    field: "RecipientEmail",
    type: "text",
    className: "col-12",
  },
  {
    title: "Approval Req Yn",
    field: "ApprovalReqYn",
    className: "col-12",
    type: "radio",
    options: [
      { title: "Yes", value: "Yes" },
      { title: "No", value: "No" },
    ],
    defaultValue: "No",
  },
];
